import { useRef, useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Eraser, Check } from "lucide-react";

export default function SignaturePad({ label, existing, onSave }) {
  const canvasRef = useRef(null);
  const drawing = useRef(false);
  const [hasInk, setHasInk] = useState(false);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    ctx.lineWidth = 2;
    ctx.lineCap = "round";
    ctx.strokeStyle = "#0f172a";
  }, []);

  const pos = (e) => {
    const r = canvasRef.current.getBoundingClientRect();
    const x = (e.touches ? e.touches[0].clientX : e.clientX) - r.left;
    const y = (e.touches ? e.touches[0].clientY : e.clientY) - r.top;
    return { x: (x / r.width) * canvasRef.current.width, y: (y / r.height) * canvasRef.current.height };
  };
  const start = (e) => { e.preventDefault(); drawing.current = true; const ctx = canvasRef.current.getContext("2d"); const p = pos(e); ctx.beginPath(); ctx.moveTo(p.x, p.y); };
  const move = (e) => { if (!drawing.current) return; e.preventDefault(); const ctx = canvasRef.current.getContext("2d"); const p = pos(e); ctx.lineTo(p.x, p.y); ctx.stroke(); setHasInk(true); };
  const end = () => { drawing.current = false; };
  const clear = () => { const c = canvasRef.current; c.getContext("2d").clearRect(0, 0, c.width, c.height); setHasInk(false); };
  const save = () => { if (!hasInk) return; onSave(canvasRef.current.toDataURL("image/png")); };

  if (existing) {
    return (
      <div>
        <div className="border border-zinc-500/35 rounded bg-white p-1 h-24 flex items-center justify-center">
          <img src={existing} alt={label} className="max-h-full" />
        </div>
        <div className="flex items-center justify-between mt-1">
          <span className="text-xs text-green-400 flex items-center gap-1"><Check className="h-3 w-3" /> {label} signed</span>
          <Button size="sm" variant="ghost" onClick={() => onSave("")} className="text-xs h-7">Re-sign</Button>
        </div>
      </div>
    );
  }

  return (
    <div>
      <canvas
        ref={canvasRef}
        width={400}
        height={96}
        className="border border-dashed border-zinc-500/40 rounded bg-white w-full h-24 touch-none cursor-crosshair"
        onMouseDown={start} onMouseMove={move} onMouseUp={end} onMouseLeave={end}
        onTouchStart={start} onTouchMove={move} onTouchEnd={end}
        data-testid={`sigpad-${label.toLowerCase()}`}
      />
      <div className="flex items-center justify-between mt-1">
        <span className="text-xs text-zinc-500">{label} — sign above</span>
        <div className="flex gap-1">
          <Button size="sm" variant="ghost" onClick={clear} className="text-xs h-7"><Eraser className="h-3 w-3 mr-1" />Clear</Button>
          <Button size="sm" onClick={save} disabled={!hasInk} className="text-xs h-7" data-testid={`sigsave-${label.toLowerCase()}`}>Save signature</Button>
        </div>
      </div>
    </div>
  );
}
